import React from "react";
import CareersMain from "./CareersMain";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import footerLogo from "../../assets/images/logos/footer-logo.png";

const CareersPage = () => {
  return (
    <>
      <Header parentMenu="careers" topbarEnable="enable" />
      <CareersMain />
      <Footer footerLogo={footerLogo} />
    </>
  );
};

export default CareersPage;
